import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { AssignmentApplyStrategyContainer } from 'packages/loanProduct/ui/assignmentStrategy/AssignmentApplyStrategyContainer';
import 'borrower/borrower.scss';

export const AssignmentApplyStrategyRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  return (
    <Box
      padding={{ base: '30px', lg: '50px 40px' }}
      margin="0 auto"
      width="100%"
      maxWidth="1600px"
    >
      <Box className="main">
        <Sentry.ErrorBoundary
          onError={() => {
            if (!routeLevelError && !toast.isActive(errorToastId)) {
              errorToastConfig.title = `Failed to load assignment apply strategy route`;
              routeLevelError = true;
              toast(errorToastConfig);
              navigate('/');
            }
          }}
        >
          <AssignmentApplyStrategyContainer />
        </Sentry.ErrorBoundary>
      </Box>
    </Box>
  );
};
